
const DateUtils = (props) => {
    let current_datetime = new Date(props.timestamp)
    let formatted_date = current_datetime.toLocaleString(undefined, {
        day:"2-digit",
        month:"2-digit", 
        year:"numeric",
        hour: '2-digit',
        minute: '2-digit'
    })
    return formatted_date;
}

export default DateUtils;